/* eslint-disable react/prop-types */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logodoo.png';
import './header.scss';

const Header = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <header className="header">
      <div className='header-items'>
      <Link to="/">
        <img src={logo} alt="Logo" className="logo" />
      </Link>     
      <input
        type="text"
        placeholder="Pretraži po nazivu..."
        className="search-bar"
        value={searchQuery}
        onChange={handleInputChange}
      />
      <div className="header-text">
        <Link to="/contact" className="contact-text">Kontakt</Link>
        
      </div>
      </div>
    </header>
  );
};

export default Header;
